export const SOFTWARE_UPDATES_PATH = '/software-updates';
export const SOFTWARE_UPDATES_CREATE_PATH = `${SOFTWARE_UPDATES_PATH}/create`;
